// Metadata for the legal pages, used by their route head() functions.
// Mirrors the props passed to LegalPageLayout in each page component.

export interface LegalMeta {
  /** Visible page heading, used as the WebPage schema name */
  name: string;
  effectiveDate: string;
  title: string;
  description: string;
}

export const LEGAL_META: Record<string, LegalMeta> = {
  "/privacy-policy": {
    name: "Privacy Policy — goptichub.com",
    effectiveDate: "6 June 2026",
    title: "Privacy Policy | GoHub",
    description:
      "This Privacy Policy describes how Global Optic Hub Ltd. (GoHub) collects, uses, discloses, and processes personal data when you visit www.goptichub.com.",
  },
  "/terms-of-use": {
    name: "Terms of Use — goptichub.com",
    effectiveDate: "6 June 2026",
    title: "Terms of Use | GoHub",
    description:
      "These Terms of Use govern your use of the website at www.goptichub.com and any subdomains, content, features, forms, and services made available through it.",
  },
  "/cookie-policy": {
    name: "goptichub.com Cookie Policy",
    effectiveDate: "March 17, 2026",
    title: "Cookie Policy | GoHub",
    description:
      "This Cookie Policy explains how GoHub uses cookies and similar technologies on goptichub.com. Read with our Privacy Policy and Terms of Use.",
  },
  "/do-not-sell": {
    name: "Do Not Sell or Share My Personal Information",
    effectiveDate: "6 June 2026",
    title: "Do Not Sell or Share My Personal Information | GoHub",
    description:
      "Opt out of sharing your personal information for cross-context behavioral advertising. Use the cookie preferences, email cs@goptichub.com, or enable GPC.",
  },
  "/wizard-consumer-terms": {
    name: "GoHub Optical Wizard – Terms of Use & Privacy Notice",
    effectiveDate: "July 12, 2026",
    title: "Optical Wizard Consumer Terms | GoHub",
    description:
      'By clicking "add lens", you have opened the GoHub Optical Wizard (the "Wizard"), a lens selection service provided by Global Optic Hub LLC.',
  },
};
